import React, { Component } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { has, map } from 'lodash';
import { appBasePath } from '../../constants/staticData';
import { defaultImageOnError } from '../../helpers'; 

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownVisible: false
    };
    this.noImageColor = this.noImageColor.bind(this);
    this.goOffline = this.goOffline.bind(this);
  }
  componentWillMount() {
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    this.state = {
      uploadImageFile: _.isEmpty(authData.profilePhoto) ? '' : authData.profilePhoto
    };
    this.noImageColor();
  }
  componentWillReceiveProps(nextprops) {
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    this.state = {
      uploadImageFile: _.isEmpty(authData.profilePhoto) ? '' : authData.profilePhoto
    };
    this.noImageColor();
  }


  noImageColor() {
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    const nameFirstLetter = authData.name.toUpperCase();
    let colorChange = '';
    if (nameFirstLetter.charCodeAt(0) > 64 && nameFirstLetter.charCodeAt(0) <= 69) {
      colorChange = { backgroundColor: '#EAABAA' };
    } else if (nameFirstLetter.charCodeAt(0) > 69 && nameFirstLetter.charCodeAt(0) <= 74) {
      colorChange = { backgroundColor: '#AED5D1' };
    } else if (nameFirstLetter.charCodeAt(0) > 74 && nameFirstLetter.charCodeAt(0) <= 79) {
      colorChange = { backgroundColor: '#D0E2B2' };
    } else if (nameFirstLetter.charCodeAt(0) > 79 && nameFirstLetter.charCodeAt(0) <= 84) {
      colorChange = { backgroundColor: '#F7E196' };
    } else if (nameFirstLetter.charCodeAt(0) > 84 && nameFirstLetter.charCodeAt(0) <= 90) {
      colorChange = { backgroundColor: '#DBDBD9' };
    } else {
      colorChange = { backgroundColor: '#C7C7E5' };
    }
    this.setState({
      profilePikColor: colorChange,
      firstCharacter: nameFirstLetter.charAt(0)
    });
  }

  goOffline() {
    this.props.actions.driverOfflineWarningShow(this.props.driverInformation.driverAcceptFlag);
    // this.props.router.push('/driver-dashboard');
    if (!this.props.driverInformation.driverAcceptFlag) {
      this.props.actions.driverOnlineOfflineMode(3, this.props.router);
    } else {
      this.props.router.push('/driver-dashboard');
    }
  }

  render() {
    let authData = JSON.parse(localStorage.getItem('businessAuthData'));
    let titleDisplay = authData ? 'name: ' + authData.name + '\n' + 'Mail: ' + authData.email : '';
    let garagePhoneNumber = 'tel:' + authData.garagePhone;
    return (
      <div title={titleDisplay}>
        <DropdownButton
          className="profile-dd"
          id={this.props.id ? this.props.id : 0}
          onToggle={() => {
            this.setState({ dropDownVisible: !this.state.dropDownVisible });
          }}
          title={
            <span>
              {this.state.uploadImageFile
                ? <img src={this.state.uploadImageFile} className="imageupl" 
                onError={(e)=>{e.target.onerror = null; e.target.src= defaultImageOnError()}}/>
                : <p className="imageupl noImage no-image-color" style={this.state.profilePikColor}>
                    {this.state.firstCharacter}
                  </p>}

              {this.state.dropDownVisible && <i className="mdi mdi-chevron-up" />}
              {!this.state.dropDownVisible && <i className="mdi mdi-chevron-down" />}
            </span>
          }
        >
          {!authData.isEmergencyDriver &&
            <div>
              <MenuItem
                eventKey="1"
                onClick={() => {
                  this.props.router.push(`${appBasePath}/User-Accounts`);
                }}
              >
                Settings <i className="mdi mdi-chevron-right" />
              </MenuItem>
              <MenuItem eventKey="2">
                Payments <i className="mdi mdi-chevron-right" />
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.props.actions.logout(this.props.router);
                  window.clearInterval();
                }}
                eventKey="3"
              >
                Sign Out
              </MenuItem>
            </div>}
          {authData.isEmergencyDriver &&
            <div>
              <li>
                <a href={garagePhoneNumber}>Call Vender</a>
              </li>
              <MenuItem
                eventKey="2"
                onClick={() => {
                  this.goOffline();
                }}
              >
                GO offline
              </MenuItem>
              <MenuItem
                onClick={() => {
                  this.props.actions.logout(this.props.router);
                  window.clearInterval();
                }}
                eventKey="3"
              >
                Sign Out
              </MenuItem>
            </div>}
        </DropdownButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dropdown.jsx